import React, { useEffect, useRef, useState } from "react";
import Alert from "react-bootstrap/Alert";
import "./flashAlert.css";

export const FLASH_DURATION_MS = 5000;
const FADE_MS = 180;

const FlashAlert = ({ variant = "success", children, duration = FLASH_DURATION_MS, className = "", onHidden }) => {
  const [visible, setVisible] = useState(Boolean(children));
  const [leaving, setLeaving] = useState(false);
  const onHiddenRef = useRef(onHidden);
  onHiddenRef.current = onHidden;

  useEffect(() => {
    if (!children) {
      setVisible(false);
      setLeaving(false);
      return undefined;
    }

    setVisible(true);
    setLeaving(false);

    const reduceMotion =
      typeof window !== "undefined" &&
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const fadeMs = reduceMotion ? 0 : FADE_MS;

    let fadeTimer;
    const hideTimer = window.setTimeout(() => {
      setLeaving(true);
      fadeTimer = window.setTimeout(() => {
        setVisible(false);
        setLeaving(false);
        if (typeof onHiddenRef.current === "function") {
          onHiddenRef.current();
        }
      }, fadeMs);
    }, duration);

    return () => {
      window.clearTimeout(hideTimer);
      window.clearTimeout(fadeTimer);
    };
  }, [children, duration]);

  if (!children || !visible) return null;

  return (
    <Alert
      variant={variant}
      className={`flash-alert${leaving ? " flash-alert--leaving" : ""}${className ? ` ${className}` : ""}`}
      role={variant === "danger" || variant === "warning" ? "alert" : "status"}
    >
      {children}
    </Alert>
  );
};

export default FlashAlert;
